export function getCookie(targetCookieName) {
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const cookieSplit = cookie.split("=");
    const cookieName = cookieSplit[0].trim();

    if (cookieName === targetCookieName) return cookieSplit[1];
  }
  return false;
}

export function setCookie(cookieName, cookieValue) {
  document.cookie = `${cookieName}=${cookieValue}; path=/;`;

  // console.log(document.cookie)
}

export function deleteCookie(targetCookieName) {
  document.cookie = `${targetCookieName}=; expiries=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
